const languages = [
	{ code: "en", title: "English", default: true },
	{ code: "nl", title: "Dutch", default: false },
];

export default languages;
